import { type FieldValues, type FormState, type Path, type UseFormRegister } from "react-hook-form";

import { TextArea, type TextAreaProps } from "@fronterahealth/frontera-ui-components/TextArea/TextArea";

export interface FormTextAreaProps<T extends FieldValues> extends Omit<TextAreaProps, "name" | "ref" | "label"> {
  register: UseFormRegister<T>;
  formState: FormState<T>;
  formKey: Path<T>;
  label?: string;
  required?: boolean;
  rows?: number;
}

export const FormTextArea = <T extends FieldValues>({
  formState,
  formKey,
  register,
  label = "",
  required = false,
  rows = 4,
  ...props
}: FormTextAreaProps<T>) => {
  const errorMessage = formState.errors[formKey]?.message?.toString() ?? "";

  return (
    <TextArea
      label={label}
      hintText={required ? undefined : props.hintText}
      errorMessage={errorMessage}
      rows={rows}
      {...register(formKey, {
        required: required ? `${label} is required` : false,
      })}
      {...props}
    />
  );
};
